import React from 'react';
import CurrencyInput from 'react-currency-input';
import mobx, { autorun, transaction } from 'mobx';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import { inject, observer } from 'mobx-react/index';
import WorkflowStepBaseComponent from '../workflow/steps/workflow-step-base';
import InvoiceStore from '../invoice/invoice-store';
import Notifications from '../utils/notification-helper';
import moment from 'moment/moment';
import ContactList from './contact-list-component';

const plugins = { dvr: validatorjs };
const fields = [
    'tcFileId',
    'date',
    'lineItem1',
    'invoiceId',
    'attention',
    'billTo',
    'billToEmail',
    'propertyAddress',
    'agentName',
    'brokerage',
];
const labels = {
    date: 'Invoice Date',
    lineItem1: 'TC Fee',
    attention: 'Attention',
    billTo: 'Bill To',
    billToEmail: 'Email',
    propertyAddress: 'Property Address',
    agentName: 'Agent Name',
    brokerage: 'Brokerage',
};
const types = {};
const rules = {
    date: 'required',
    lineItem1: 'required',
    attention: 'required',
    billToEmail: ['regex:/^([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}(,|$))+$/'],
    propertyAddress: 'required',
    agentName: 'required',
    billTo: 'required',
    brokerage: 'required',
};
const extra = {};
const disabled = { propertyAddress: 'disabled', agentName: 'required' };
const bindings = {};

const makeInvoiceForm = function() {
    return new MobxReactForm({ fields, rules, bindings, labels, types, disabled, extra }, { plugins });
};
@inject('appStore')
@observer
export default class CreateInvoiceComponent extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
        this.form = makeInvoiceForm();
        this.state = { selectedContactId: null };
        this.invoiceStore = new InvoiceStore(appStore);
    }

    updateFieldsFromStore(invoice) {
        _.each(mobx.toJS(invoice), (value, key) => {
            this.form.$(key).set(_.isUndefined(value) ? '' : value);
        });
    }

    componentDidMount() {
        this.invoiceStore.resetInvoice();
        appStore.addIsLoadingStore('invoice-step-store', this.invoiceStore);

        //Initialize form from invoice model
        this.invoiceStore.invoice.propertyAddress = this.props.appStore.tcFileStore.selectedFile.propertyAddress;
        this.invoiceStore.invoice.agentName = this.props.appStore.tcFileStore.selectedFile.agent.name;
        this.invoiceStore.invoice.brokerage = this.props.appStore.tcFileStore.selectedFile.subscriberName;
        this.invoiceStore.invoice.tcFileId = this.props.appStore.tcFileStore.selectedFile.tcFileId;

        this.updateFieldsFromStore(this.invoiceStore.invoice);
    }

    onChangeEvent(contact) {
        if (!contact) return;

        //Update Form//
        this.setState({ selectedContactId: contact.contactId });
        this.updateFieldsFromStore({
            attention: contact.firstName + ' ' + contact.lastName,
            billTo: contact.companyName,
            billToEmail: contact.email,
        });
    }

    handleInvoiceCreate() {
        //Get all values from form
        let formattedFields = {};
        _.each(this.form.values(), (value, key) => {
            if (this.form.fields.get(key).$extra === 'date') {
                if (!moment.isMoment(value)) {
                    value = moment(value);
                }
                formattedFields[key] = value.isValid() ? value.format() : null;
            } else {
                formattedFields[key] = value;
            }
        });

        //Update Model with form values
        Object.assign(this.invoiceStore.invoice, formattedFields);

        this.form.validate({ showErrors: true }).then((form) => {
            if (form.isValid) {
                this.invoiceStore
                    .createInvoice()
                    .then((invoiceResult) => {
                        this.props.handleInvoiceCreated(this.invoiceStore.invoice, invoiceResult);
                        window.location.reload()
                        window.open(invoiceResult.signedUrl, '_blank');
                        appStore.viewStore.hideInvoiceFileDialogModal()
                    })
                    .catch((error) => {
                        Notifications.ToastError(error.message);
                    });
            }
        });
    }

    buildAgentContact() {
        const { selectedFile } = this.props.appStore.tcFileStore;
        return {
            contactType: 'Agent',
            contactTypeEnum: -1,
            contactTypeId: -1,
            companyName: selectedFile.agent.subscriberName,
            contactId: selectedFile.agent.agentContactId,
            transactionId: selectedFile.transactionId,
            ...selectedFile.agent.emailContact,
        };
    }

    render() {
        return (
            <div className="row">
                <form key={`invoice-step`}>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`date`).id} className="required">
                                {this.form.$(`date`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`date`).bind()} />
                            <p className="form-error">{this.form.$(`date`).error}</p>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`propertyAddress`).id} className="required">
                                {this.form.$(`propertyAddress`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`propertyAddress`).bind()} />
                            <p className="form-error">{this.form.$(`propertyAddress`).error}</p>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="invoice-attn">File Contacts</label>
                            <ContactList
                                file={appStore.tcFileStore.selectedFile}
                                onChangeEvent={this.onChangeEvent.bind(this)}
                                defaultContacts={[this.buildAgentContact()]}
                            />
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`billTo`).id} className="required">
                                {this.form.$(`billTo`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`billTo`).bind()} />
                            <p className="form-error">{this.form.$(`billTo`).error}</p>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`billToEmail`).id}>{this.form.$(`billToEmail`).label}</label>
                            <input className="form-control" {...this.form.$(`billToEmail`).bind()} />
                            <p className="form-error">{this.form.$(`billToEmail`).error}</p>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`attention`).id} className="required">
                                {this.form.$(`attention`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`attention`).bind()} />
                            <p className="form-error">{this.form.$(`attention`).error}</p>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`agentName`).id} className="required">
                                {this.form.$(`agentName`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`agentName`).bind()} />
                            <p className="form-error">{this.form.$(`agentName`).error}</p>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`brokerage`).id} className="required">
                                {this.form.$(`brokerage`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`brokerage`).bind()} />
                            <p className="form-error">{this.form.$(`brokerage`).error}</p>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`lineItem1`).id} className="required">
                                {this.form.$(`lineItem1`).label}
                            </label>
                            <CurrencyInput className="form-control" {...this.form.$(`lineItem1`).bind()} prefix="$" />
                            <p className="form-error">{this.form.$(`lineItem1`).error}</p>
                        </div>
                    </div>
                </form>
                <div className="col-xs-12 col-sm-12">
                    <div className="form-group">
                        <button
                            className="btn btn-success"
                            disabled={this.invoiceStore.isLoading}
                            onClick={this.handleInvoiceCreate.bind(this)}
                        >
                            Create Invoice
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/create-invoice-component.js